export enum TextDirection {
  LTR = 'ltr',
  RTL = 'rtl',
}
